module.exports = __webpack_public_path__ + "img/study.dbe551d7.png";